module.exports = wc.blocksCheckout;